import {
    AlertText,
    AlertTextWrapper,
    AlertWrapper,
} from '@/src/common/components/elements/Alerts/StyledComponents'
import { TextInputWithLabel } from '@/src/common/components/elements/Forms/TextInputWithLabel'
import { PromoButton } from '@/src/modules/cart/StyledComponents'
import { styled } from '@/src/stitches.config'
import {
    faCheckSquare,
    faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons'
import {
    faChevronDown,
    faChevronUp,
    faTag,
} from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import Button from '../../marketing/buttons/Button'

const FATag = styled(FontAwesomeIcon, {
    color: '$primary',
    width: '21px',
})

const PromoSectionWrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    jc: 'space-between',
    width: '100%',
    p: '5px 0px 5px',
    m: '0px 2px 50px',
    borderBottom: `1px solid $mediumGray`,
})

const OpenPromoSectionWrapper = styled('div', {
    display: 'flex',
    gap: '10px',
    flexDirection: 'column',
    jc: 'space-between',
    width: '100%',
    alignItems: 'center',
    '@sm': {
        flexDirection: 'row',
    },
})

const PromoSectionIconText = styled('div', {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '10px',
    fontSize: '20px',
})

const PromoSectionHeaderWrapper = styled('div', {
    display: 'flex',
    alignItems: 'center',
    jc: 'space-between',
    width: '100%',
    p: '5px 0px 15px',
    m: '20px 2px 10px',
    cursor: 'pointer',
})

const PromoTextInputWithLabel = styled('div', {
    width: '100%',
    '@sm': {
        flex: 2,
    },
})

const ApplyButton = styled('div', {
    width: '100%',
    marginTop: '10px',
    '@sm': {
        flex: 1,
        marginTop: '0px',
    },
})

const ResultsMessageWrap = styled('div', {
    marginTop: 20,
    mb: 10,
})

const PromoCodeSection = ({
    promoCode,
    setPromoCode,
    updatePromoCode,
    hasPromoDiscount,
    errorMessage,
}: {
    promoCode: String | undefined
    setPromoCode: Function
    updatePromoCode: Function | undefined
    hasPromoDiscount: boolean
    errorMessage: string | undefined
}) => {
    const [promoCodeApplyOpen, setPromoCodeApplyOpen] = useState<boolean>(false)

    const showResultsMessage = () => {
        return (
            <AlertWrapper variant={'success'}>
                <FontAwesomeIcon icon={faCheckSquare} />
                <AlertTextWrapper>
                    <AlertText>
                        Promo code has been applied successfully. Enjoy!
                    </AlertText>
                </AlertTextWrapper>
            </AlertWrapper>
        )
    }

    const showErrorMessage = () => {
        return (
            <AlertWrapper variant={'error'}>
                <FontAwesomeIcon icon={faExclamationTriangle} />
                <AlertTextWrapper>
                    <AlertText>{errorMessage}</AlertText>
                </AlertTextWrapper>
            </AlertWrapper>
        )
    }

    return (
        <PromoSectionWrapper>
            <PromoSectionHeaderWrapper
                onClick={() => setPromoCodeApplyOpen(!promoCodeApplyOpen)}
            >
                <PromoSectionIconText>
                    <FATag icon={faTag} size="2x" />
                    Apply a promo code
                </PromoSectionIconText>
                <PromoButton>
                    <FATag
                        icon={promoCodeApplyOpen ? faChevronUp : faChevronDown}
                        size="1x"
                    />
                </PromoButton>
            </PromoSectionHeaderWrapper>
            {promoCodeApplyOpen && (
                <>
                    <OpenPromoSectionWrapper>
                        <PromoTextInputWithLabel>
                            <TextInputWithLabel
                                type="text"
                                value={promoCode || ''}
                                placeholder={'Enter a valid promo code'}
                                onChange={(event: {
                                    target: {
                                        value: React.SetStateAction<
                                            string | undefined
                                        >
                                    }
                                }) => {
                                    const promoValue = event.target.value
                                    setPromoCode(
                                        typeof promoValue === 'string'
                                            ? promoValue.trim().toUpperCase()
                                            : promoValue
                                    )
                                }}
                            />
                        </PromoTextInputWithLabel>
                        <ApplyButton>
                            <Button
                                onClick={async () => {
                                    if (updatePromoCode) {
                                        updatePromoCode(promoCode)
                                    }
                                }}
                                style={{ width: '100%' }}
                                label={'Apply'}
                            />
                        </ApplyButton>

                        {/* @TODO: The error code and what happens when the code is applied to not match the wireframes and need to be adjusted */}
                    </OpenPromoSectionWrapper>

                    <ResultsMessageWrap>
                        {hasPromoDiscount && showResultsMessage()}
                        {errorMessage &&
                            errorMessage !== '' &&
                            showErrorMessage()}
                    </ResultsMessageWrap>
                </>
            )}
        </PromoSectionWrapper>
    )
}

export default PromoCodeSection
